// Get Shopify Tokens
export const GET_SHOPIFY_TOKENS_REQUEST = 'GET_SHOPIFY_TOKENS_REQUEST';
export const GET_SHOPIFY_TOKENS_DONE = 'GET_SHOPIFY_TOKENS_DONE';
export const GET_SHOPIFY_TOKENS_FAILED = 'GET_SHOPIFY_TOKENS_FAILED';

// Operations
export const SHOPIFY_TOKENS_SET_PAGE = 'PROMOTIONS_SET_PAGE';